<template>
  <div class="crud preventive-module">
    <div class="container-fluid preventive-module__inner">
      <vm-row class="heading" vm-w="12">
        <vm-col vm-type="flex" vm-align="center" vm-lg="8" vm-sm="12">
          <div>
            <h2>Preventivo y correctivo</h2>
            <span>Consulta de órdenes, estados de revisión y acciones correctivas.</span>
          </div>
        </vm-col>
        <vm-col vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg="4" vm-sm="12">
          <vm-button type="border" icon="monitor-outline" @click="liveDashboardVisible = true">
            Dashboard en vivo
          </vm-button>
        </vm-col>
      </vm-row>

      <div class="preventive-module__main-tabs" role="tablist" aria-label="Secciones del módulo">
        <button
          type="button"
          role="tab"
          class="preventive-module__main-tab"
          :class="{ 'is-active': mainTab === 'listado' }"
          :aria-selected="mainTab === 'listado'"
          tabindex="0"
          id="tab-listado"
          aria-controls="panel-listado"
          @click="mainTab = 'listado'"
        >
          Preventivo / correctivo
        </button>
        <button
          type="button"
          role="tab"
          class="preventive-module__main-tab"
          :class="{ 'is-active': mainTab === 'metricas' }"
          :aria-selected="mainTab === 'metricas'"
          tabindex="0"
          id="tab-metricas"
          aria-controls="panel-metricas"
          @click="mainTab = 'metricas'"
        >
          Métricas
        </button>
      </div>

      <div
        v-show="mainTab === 'listado'"
        role="tabpanel"
        id="panel-listado"
        aria-labelledby="tab-listado"
        class="preventive-module__panel preventive-module__panel--listado"
      >
        <vm-row class="mb-2" vm-w="12">
          <vm-col class="preventive-module__category-filters" vm-sm="12">
            <button
              v-for="tab in categoryTabs"
              :key="tab.key"
              type="button"
              class="preventive-module__chip"
              :class="{ 'is-active': category === tab.key }"
              @click="setCategory(tab.key)"
            >
              {{ tab.label }}
            </button>
          </vm-col>
        </vm-row>

        <vm-row class="preventive-module__table-row" vm-w="12">
          <vm-col class="card preventive-module__table-card" vm-sm="12">
            <div class="d-flex justify-content-between align-items-center flex-wrap preventive-module__toolbar">
              <vm-input
                ref="search"
                icon="search"
                size="small"
                placeholder="Buscar por folio"
                v-model="folioSearch"
                width="280px"
                @keyup.enter="reloadFromFirstPage"
              />
              <div class="preventive-module__export-box">
                <vm-input
                  type="date"
                  size="small"
                  label="Desde"
                  v-model="exportDateFrom"
                  width="170px"
                />
                <vm-input
                  type="date"
                  size="small"
                  label="Hasta"
                  v-model="exportDateTo"
                  width="170px"
                />
                <vm-button
                  type="border"
                  icon="download-outline"
                  :disabled="!exportParams"
                  :loading="exportLoading"
                  @click="downloadExport"
                >
                  Exportar Excel
                </vm-button>
              </div>
            </div>

            <vm-table multiple v-model="selected" max-height="calc(100vh - 260px)" :data="orders">
              <template slot="thead">
                <vm-th>Folio</vm-th>
                <vm-th>Razón social</vm-th>
                <vm-th>Estado preventivo</vm-th>
                <vm-th>Bypass</vm-th>
                <vm-th>Estado correctivo</vm-th>
                <vm-th>Acciones</vm-th>
              </template>
              <template slot-scope="{ data }">
                <vm-tr
                  v-for="tr in data"
                  :data="tr"
                  :key="tr.id"
                >
                  <vm-td>{{ tr.folio }}</vm-td>
                  <vm-td>{{ tr.social_reason }}</vm-td>
                  <vm-td>{{ tr.preventive_result_label }}</vm-td>
                  <vm-td>{{ tr.preventive_bypass_label }}</vm-td>
                  <vm-td>{{ tr.corrective_status_label }}</vm-td>
                  <vm-td>
                    <vm-dropdown vm-custom-content vm-trigger-click vm-trigger-outside-click>
                      <vm-button type="flat" icon="more-horizotnal" color="#afbbc6" />
                      <vm-dropdown-menu>
                        <!-- <vm-dropdown-item
                          v-if="tr.status === 3"
                          class="d-flex justify-content-between"
                          @click="printRecord(tr)"
                        >
                          <vm-icon icon="printer-outline" />
                          <span>&nbsp;Imprimir</span>
                        </vm-dropdown-item> -->
                        <vm-dropdown-item
                          class="d-flex justify-content-between"
                          @click="goCorrective(tr)"
                        >
                          <vm-icon icon="edit-outline" />
                          <span>&nbsp;Revisión correctiva</span>
                        </vm-dropdown-item>
                      </vm-dropdown-menu>
                    </vm-dropdown>
                  </vm-td>
                </vm-tr>
              </template>
            </vm-table>

            <vm-pagination :total="pagination.totalPages" v-model="currentPage" goto />
          </vm-col>
        </vm-row>
      </div>

      <div
        v-show="mainTab === 'metricas'"
        role="tabpanel"
        id="panel-metricas"
        aria-labelledby="tab-metricas"
        class="preventive-module__panel preventive-module__panel--metricas"
      >
        <div class="card preventive-module__metrics-filters mb-3">
          <div class="preventive-module__metrics-filters-grid">
            <div>
              <vm-select v-model="metricsYear" label="Año">
                <vm-select-item v-for="year in yearOptions" :key="year" :value="year" :text="String(year)" />
              </vm-select>
            </div>
            <div>
              <vm-select v-model="metricsMonth" label="Mes">
                <vm-select-item v-for="month in monthOptions" :key="month.value" :value="month.value" :text="month.label" />
              </vm-select>
            </div>
            <div class="preventive-module__metrics-actions">
              <vm-button color="primary" :loading="metricsLoading" @click="fetchMetrics">
                Cargar métricas
              </vm-button>
            </div>
          </div>
        </div>

        <vm-row vm-w="12">
          <vm-col vm-md="6" vm-sm="12">
            <div class="card preventive-module__metric-card">
              <div class="preventive-module__metric-header">
                <h5 style="font-size: 1.125rem;">Total errores preventivos</h5>
                <div class="preventive-module__scope-switch">
                  <button type="button" :class="{ 'is-active': preventiveErrorsScope === 'global' }" @click="preventiveErrorsScope = 'global'">Global</button>
                  <button type="button" :class="{ 'is-active': preventiveErrorsScope === 'monthly' }" @click="preventiveErrorsScope = 'monthly'">Mensual</button>
                </div>
              </div>
              <vm-table :data="preventiveErrorsRows">
                <template slot="thead">
                  <vm-th>Usuario</vm-th>
                  <vm-th>Partidas</vm-th>
                  <vm-th>Partidas con error</vm-th>
                  <vm-th>% Error</vm-th>
                </template>
                <template slot-scope="{ data }">
                  <vm-tr v-for="row in data" :key="row.user_name" :data="row">
                    <vm-td>{{ row.user_name }}</vm-td>
                    <vm-td>{{ row.total_reviews }}</vm-td>
                    <vm-td>{{ row.total_errors }}</vm-td>
                    <vm-td>{{ row.error_rate }}%</vm-td>
                  </vm-tr>
                </template>
              </vm-table>
              <apexchart type="bar" height="260" :options="preventiveErrorsChartOptions" :series="preventiveErrorsChartSeries" />
            </div>
          </vm-col>

          <vm-col vm-md="6" vm-sm="12">
            <div class="card preventive-module__metric-card">
              <div class="preventive-module__metric-header">
                <h5 style="font-size: 1.125rem;">Total revisiones correctivas</h5>
                <div class="preventive-module__scope-switch">
                  <button type="button" :class="{ 'is-active': correctiveScope === 'global' }" @click="correctiveScope = 'global'">Global</button>
                  <button type="button" :class="{ 'is-active': correctiveScope === 'monthly' }" @click="correctiveScope = 'monthly'">Mensual</button>
                </div>
              </div>
              <vm-table :data="correctiveRows">
                <template slot="thead">
                  <vm-th>Usuario</vm-th>
                  <vm-th>Partidas corregidas</vm-th>
                </template>
                <template slot-scope="{ data }">
                  <vm-tr v-for="row in data" :key="row.user_name" :data="row">
                    <vm-td>{{ row.user_name }}</vm-td>
                    <vm-td>{{ row.total_corrective_reviews }}</vm-td>
                  </vm-tr>
                </template>
              </vm-table>
              <apexchart type="bar" height="260" :options="correctiveChartOptions" :series="correctiveChartSeries" />
            </div>
          </vm-col>
        </vm-row>

        <div class="card preventive-module__metric-card mt-2">
          <h5 style="font-size: 1.125rem;">Top 5 razones sociales con incidencia (mensual)</h5>
          <vm-table :data="topIncidentsRows">
            <template slot="thead">
              <vm-th>Razón social</vm-th>
              <vm-th>Incidencias</vm-th>
            </template>
            <template slot-scope="{ data }">
              <vm-tr v-for="row in data" :key="row.social_reason" :data="row">
                <vm-td>{{ row.social_reason }}</vm-td>
                <vm-td>{{ row.total_incidents }}</vm-td>
              </vm-tr>
            </template>
          </vm-table>
          <apexchart type="bar" height="300" :options="topIncidentsChartOptions" :series="topIncidentsChartSeries" />
        </div>

        <vm-row class="mt-2" vm-w="12">
          <vm-col vm-md="6" vm-sm="12">
            <div class="card preventive-module__metric-card">
              <div class="preventive-module__metric-header">
                <h5 style="font-size: 1.125rem;">Tasa de bypass</h5>
                <div class="preventive-module__scope-switch">
                  <button type="button" :class="{ 'is-active': bypassScope === 'global' }" @click="bypassScope = 'global'">Global</button>
                  <button type="button" :class="{ 'is-active': bypassScope === 'monthly' }" @click="bypassScope = 'monthly'">Mensual</button>
                </div>
              </div>
              <vm-table :data="bypassRows">
                <template slot="thead">
                  <vm-th>Usuario</vm-th>
                  <vm-th>Revisiones</vm-th>
                  <vm-th>Bypass</vm-th>
                  <vm-th>% Bypass</vm-th>
                </template>
                <template slot-scope="{ data }">
                  <vm-tr v-for="row in data" :key="row.user_name" :data="row">
                    <vm-td>{{ row.user_name }}</vm-td>
                    <vm-td>{{ row.total_reviews }}</vm-td>
                    <vm-td>{{ row.total_bypass }}</vm-td>
                    <vm-td>{{ row.bypass_rate }}%</vm-td>
                  </vm-tr>
                </template>
              </vm-table>
            </div>
          </vm-col>

          <vm-col vm-md="6" vm-sm="12">
            <div class="card preventive-module__metric-card">
              <h5 style="font-size: 1.125rem;">Errores por tipo (mensual)</h5>
              <vm-table :data="errorsByTypeRows">
                <template slot="thead">
                  <vm-th>Tipo de error</vm-th>
                  <vm-th>Preventivos</vm-th>
                  <vm-th>Correctivos</vm-th>
                  <vm-th>Total</vm-th>
                </template>
                <template slot-scope="{ data }">
                  <vm-tr v-for="row in data" :key="row.error_catalog_name" :data="row">
                    <vm-td>{{ row.error_catalog_name }}</vm-td>
                    <vm-td>{{ row.total_preventive }}</vm-td>
                    <vm-td>{{ row.total_corrective }}</vm-td>
                    <vm-td>{{ row.total }}</vm-td>
                  </vm-tr>
                </template>
              </vm-table>
              <apexchart type="donut" height="300" :options="errorsByTypeChartOptions" :series="errorsByTypeChartSeries" />
            </div>
          </vm-col>
        </vm-row>
      </div>
    </div>
    <live-dashboard-modal :visible="liveDashboardVisible" @close="liveDashboardVisible = false" />
  </div>
</template>

<script>
import axios from 'axios'
import { createNamespacedHelpers } from 'vuex'
import LiveDashboardModal from './LiveDashboardModal.vue'
const { mapGetters, mapActions } = createNamespacedHelpers('Orders')

export default {
  name: 'Orders',
  components: {
    LiveDashboardModal
  },
  data () {
    const now = new Date()
    return {
      liveDashboardVisible: false,
      mainTab: 'listado',
      category: 'todas',
      folioSearch: '',
      exportDateFrom: '',
      exportDateTo: '',
      exportLoading: false,
      currentPage: 1,
      selected: [],
      metricsYear: now.getFullYear(),
      metricsMonth: now.getMonth() + 1,
      metricsLoading: false,
      preventiveErrorsScope: 'monthly',
      correctiveScope: 'monthly',
      bypassScope: 'monthly',
      categoryTabs: [
        { key: 'todas', label: 'Todas' },
        { key: 'pendientes', label: 'Pendientes' },
        { key: 'errores', label: 'Con errores' },
        { key: 'completadas', label: 'Completada' }
      ]
    }
  },
  computed: {
    ...mapGetters(['orders', 'pagination', 'metrics']),
    yearOptions () {
      const currentYear = new Date().getFullYear()
      const minYear = currentYear - 4
      const years = []
      for (let year = currentYear + 1; year >= minYear; year--) {
        years.push(year)
      }
      return years
    },
    monthOptions () {
      return [
        { value: 1, label: 'Enero' },
        { value: 2, label: 'Febrero' },
        { value: 3, label: 'Marzo' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Mayo' },
        { value: 6, label: 'Junio' },
        { value: 7, label: 'Julio' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Septiembre' },
        { value: 10, label: 'Octubre' },
        { value: 11, label: 'Noviembre' },
        { value: 12, label: 'Diciembre' }
      ]
    },
    metricsParams () {
      const year = Number(this.metricsYear)
      const month = Number(this.metricsMonth)
      const lastDay = new Date(year, month, 0).getDate()
      return {
        year_from: this.buildIso(year, 1, 1, 0, 0, 0),
        year_to: this.buildIso(year, 12, 31, 23, 59, 59),
        month_from: this.buildIso(year, month, 1, 0, 0, 0),
        month_to: this.buildIso(year, month, lastDay, 23, 59, 59),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    },
    exportParams () {
      if (!this.exportDateFrom || !this.exportDateTo) {
        return null
      }

      const [fromY, fromM, fromD] = this.parseDateParts(this.exportDateFrom)
      const [toY, toM, toD] = this.parseDateParts(this.exportDateTo)

      if (!fromY || !fromM || !fromD || !toY || !toM || !toD) {
        return null
      }

      return {
        date_from: this.buildIso(fromY, fromM, fromD, 0, 0, 0),
        date_to: this.buildIso(toY, toM, toD, 23, 59, 59),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    },
    preventiveErrorsRows () {
      const section = this.metrics && this.metrics.preventive_errors
      return (section && section[this.preventiveErrorsScope]) || []
    },
    correctiveRows () {
      const section = this.metrics && this.metrics.corrective_reviews
      return (section && section[this.correctiveScope]) || []
    },
    bypassRows () {
      const section = this.metrics && this.metrics.bypass_rate
      return (section && section[this.bypassScope]) || []
    },
    topIncidentsRows () {
      return (this.metrics && this.metrics.top_incidents) || []
    },
    errorsByTypeRows () {
      return (this.metrics && this.metrics.errors_by_type) || []
    },
    preventiveErrorsChartSeries () {
      return [
        { name: 'Partidas revisadas', data: this.preventiveErrorsRows.map(r => r.total_reviews) },
        { name: 'Partidas con error', data: this.preventiveErrorsRows.map(r => r.total_errors) }
      ]
    },
    preventiveErrorsChartOptions () {
      return {
        chart: { toolbar: { show: false } },
        xaxis: { categories: this.preventiveErrorsRows.map(r => r.user_name) },
        legend: { position: 'top' }
      }
    },
    correctiveChartSeries () {
      return [
        { name: 'Correctivos', data: this.correctiveRows.map(r => r.total_corrective_reviews) }
      ]
    },
    correctiveChartOptions () {
      return {
        chart: { toolbar: { show: false } },
        xaxis: { categories: this.correctiveRows.map(r => r.user_name) }
      }
    },
    topIncidentsChartSeries () {
      return [
        { name: 'Incidencias', data: this.topIncidentsRows.map(r => r.total_incidents) }
      ]
    },
    topIncidentsChartOptions () {
      return {
        chart: { toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true } },
        xaxis: { categories: this.topIncidentsRows.map(r => r.social_reason) }
      }
    },
    errorsByTypeChartSeries () {
      return this.errorsByTypeRows.map(r => r.total)
    },
    errorsByTypeChartOptions () {
      return {
        labels: this.errorsByTypeRows.map(r => r.error_catalog_name),
        legend: { position: 'bottom' }
      }
    }
  },
  watch: {
    currentPage (page) {
      this.fetchPage(page)
    },
    mainTab (value) {
      if (value === 'metricas' && !this.metrics && !this.metricsLoading) {
        this.fetchMetrics()
      }
    }
  },
  created () {
    this.fetchPage(1)
    if (this.mainTab === 'metricas' && !this.metrics) {
      this.fetchMetrics()
    }
  },
  methods: {
    ...mapActions(['loadPreventiveModuleRecords', 'loadPreventiveMetrics', 'printReport']),
    fetchPage (page) {
      this.loadPreventiveModuleRecords({
        page,
        category: this.category,
        folio: this.folioSearch
      })
    },
    setCategory (key) {
      this.category = key
      this.currentPage = 1
      this.fetchPage(1)
    },
    reloadFromFirstPage () {
      this.currentPage = 1
      this.fetchPage(1)
    },
    parseDateParts (dateString) {
      if (!dateString || typeof dateString !== 'string') {
        return [0, 0, 0]
      }

      const parts = dateString.split('-')
      return [
        Number(parts[0]),
        Number(parts[1]),
        Number(parts[2])
      ]
    },
    printRecord (record) {
      this.printReport(record.id)
    },
    downloadExport () {
      if (!this.exportParams || this.exportLoading) {
        return
      }

      this.exportLoading = true
      try {
        const params = new URLSearchParams(this.exportParams).toString()
        window.open(`${axios.defaults.baseURL}orders/preventive-export?${params}`)
      } finally {
        this.exportLoading = false
      }
    },
    goCorrective (record) {
      this.$router.push({
        name: 'order_corrective_review',
        params: { id: record.id }
      })
    },
    buildIso (year, month, day, h, m, s) {
      const diffMins = -new Date().getTimezoneOffset()
      const sign = diffMins >= 0 ? '+' : '-'
      const abs = Math.abs(diffMins)
      const tzoH = String(Math.floor(abs / 60)).padStart(2, '0')
      const tzoM = String(abs % 60).padStart(2, '0')
      const pad = n => String(n).padStart(2, '0')
      return `${year}-${pad(month)}-${pad(day)}T${pad(h)}:${pad(m)}:${pad(s)}${sign}${tzoH}:${tzoM}`
    },
    async fetchMetrics () {
      this.metricsLoading = true
      try {
        await this.loadPreventiveMetrics(this.metricsParams)
      } finally {
        this.metricsLoading = false
      }
    }
  }
}
</script>

<style lang="scss">
.preventive-module {
  min-height: calc(100vh - 72px);

  &__inner {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 72px);
  }

  &__main-tabs {
    display: flex;
    gap: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    margin-bottom: 16px;
  }

  &__main-tab {
    appearance: none;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    color: #6b7280;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 500;
    margin-bottom: -1px;
    padding: 10px 18px 12px;
    transition: color 0.15s ease, border-color 0.15s ease;

    &:hover {
      color: #374151;
    }

    &.is-active {
      border-bottom-color: rgba(163, 73, 54, 1);
      color: rgba(163, 73, 54, 1);
    }
  }

  &__panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    &--listado {
      flex: 1;
    }

    &--metricas {
      overflow: auto;
    }
  }

  &__table-row {
    flex: 1;
    min-height: 0;
  }

  &__table-card {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  &__metrics-filters {
    padding: 12px 16px;
  }

  &__metrics-filters-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(180px, 1fr));
    gap: 12px;
    align-items: end;
  }

  &__metrics-actions {
    display: flex;
    justify-content: flex-end;
  }

  &__label {
    display: block;
    margin-bottom: 6px;
    color: #4b5563;
    font-size: 0.8125rem;
    font-weight: 600;
  }

  &__metric-card {
    padding: 14px 16px;
    margin-bottom: 10px;
  }

  &__metric-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  &__scope-switch {
    display: inline-flex;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    overflow: hidden;

    button {
      border: none;
      background: #fff;
      color: #4b5563;
      font-size: 0.75rem;
      font-weight: 600;
      padding: 5px 10px;
      cursor: pointer;

      &.is-active {
        background: rgba(163, 73, 54, 0.12);
        color: rgba(120, 53, 38, 1);
      }
    }
  }

  &__toolbar {
    flex-shrink: 0;
    margin-bottom: 12px;
  }

  &__export-box {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  &__category-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__chip {
    appearance: none;
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    color: #374151;
    cursor: pointer;
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1.25;
    padding: 7px 14px;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

    &:hover {
      background: #e5e7eb;
      border-color: #9ca3af;
      color: #1f2937;
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(163, 73, 54, 0.35);
    }

    &.is-active {
      background: rgba(163, 73, 54, 0.12);
      border-color: rgba(163, 73, 54, 0.9);
      color: rgba(120, 53, 38, 1);
    }
  }

  @media (max-width: 992px) {
    &__metrics-filters-grid {
      grid-template-columns: 1fr;
    }

    &__metrics-actions {
      justify-content: flex-start;
    }

    &__export-box {
      width: 100%;
      justify-content: flex-start;
    }
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
</style>
